module.exports = __webpack_public_path__ + "static/media/ic_menu.c275e518.svg";